import React from "react";

import FAQCollapse from "./FAQCollapse";
import { Container, Title, FAQsContainer } from "./styled";

const FAQSection = () => {
  const footerBgColor = "#D6D5D515";

  return (
    <Container>
      <Title>FAQs</Title>
      <FAQsContainer>
        <FAQCollapse />
      </FAQsContainer>
    </Container>
  );
};

export default FAQSection;
